import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { howItWorksTrns } from "src/page-components/opportunities/trns";
import { HowItWorksSidebarItem } from "./HowItWorksSidebarItem";
import { HowItWorksSidebarSubtitle } from "./HowItWorksSidebarSubtitle";
import { SIDEBAR_ITEMS } from "./constants";
import "src/components/Search/scrollbar.scss";

export const HowItWorksSidebar = () => {
  const [activeLink, setActiveLink] = useState(null);
  const { t } = useTranslation();

  const onItemClick = (id) => {
    setActiveLink(id);
  };

  return (
    <div className="md:sticky top-19 md:max-w-100 w-full md:h-screen">
      <div className="md:max-h-full-screen-minus-17 md:overflow-auto scrollbar">
        <h3 className="text-purple-base text-2xl font-semibold">
          {t(howItWorksTrns.tableOfContent)}
        </h3>

        <ul>
          {SIDEBAR_ITEMS.map(({ title, id, subtitles }) => (
            <HowItWorksSidebarItem key={id} title={title}>
              {/* subtitles list */}
              <div className="flex flex-col pl-2 md:pl-5">
                {subtitles.map((subtitle) => (
                  <HowItWorksSidebarSubtitle
                    key={subtitle.id}
                    onItemClick={onItemClick}
                    activeLink={activeLink}
                    {...subtitle}
                  />
                ))}
              </div>
            </HowItWorksSidebarItem>
          ))}
        </ul>
      </div>
    </div>
  );
};
